import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { LauncherInfo } from 'src/api/launcher-api/launcher-api.interface'
import { Wbs } from 'src/api/petabo-api/petabo-api.interface'
import { PetaboApiService } from 'src/api/petabo-api/petabo-api.service'

@Component({
  selector: 'app-petabo-information',
  templateUrl: './petabo-information.component.html',
  styleUrls: ['./petabo-information.component.scss']
})
export class PetaboInformationComponent implements OnInit {
  title = 'お知らせ'
  loading = true
  launchers: LauncherInfo[]
  petaboNotificationList: Wbs[] = []
  public viewCd = 'myidea-information'
  petaboFqdn = 'petabo.myidea.information'

  constructor(private petaboApiService: PetaboApiService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.getPetaboList()
  }

  // Petaboからお知らせ取得
  public async getPetaboList(): Promise<void> {
    this.loading = true
    this.petaboNotificationList = []
    const ret = await this.petaboApiService.getPetabo(this.petaboFqdn)
    if (ret?.resultCode !== 0) {
      return
    }
    const now = new Date().getTime()
    let filteredList = ret.data.filter((item) => {
      const start = item.profiles?.periodFrom ? new Date(item.profiles.periodFrom).getTime() : Number.NEGATIVE_INFINITY
      const end = item.profiles?.periodTo ? new Date(item.profiles.periodTo).getTime() : Number.POSITIVE_INFINITY
      return start <= now && now <= end
    })

    // 最新のものを上に表示する createdAtでソート
    // createdAt: '2024-12-12T16:39:32.9062696+09:00'
    // 最新を上に表示するため、降順ソート
    filteredList = filteredList.sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    })
    this.petaboNotificationList = filteredList
    this.loading = false
  }

  notificationLink(path: string): void {
    if (path?.startsWith('http')) {
      window.open(path, '_blank')
    } else {
      this.router.navigate([path])
    }
  }

  // 表示する日付を取得するヘルパーメソッド
  getDisplayDate(notification: Wbs): string {
    if (notification.profiles?.periodFrom) {
      return notification.profiles.periodFrom
    }
    return notification.createdAt.toString()
  }
}
